<template>
  <div class="section-author" v-if="showSection">
    <div class="avatar-wrap" @click="$hb_tools.linkToUserPage(sectionData.userid)" :class="{ onload: avatar_onload }">
      <img class="avatar" v-hb-img.src="sectionData.avatar" ref="avatar" @load="avatar_onload = true"/>
      <img
        v-if="sectionData.avatar_decoration"
        v-hb-img.src="sectionData.avatar_decoration.src_url"
        class="avatar-decoration"
        ref="avatar"
      />
    </div>
    <div class="user-wrap">
      <div class="user-info">
        <div class="user-name" @click="$hb_tools.linkToUserPage(sectionData.userid)">{{ sectionData.username }}</div>
        <div class="medals-wrap"  ref="medals">
          <span class="medal-wrap medal" v-for="medal, index in medalInfo" :key="index">
            <img v-hb-img.src="medal.img_url" alt="medal" />
            <span class="medal-name"
              v-if="medal.status == 1"
              :style="{ color: medal.color, background: colorHandler(medal.color)}"
              >{{ medal.name }}</span
            >
          </span>
          <div v-if="sectionData.level_info && sectionData.level_info.status == 1" class="medal-wrap level">
            <div class="medal-name static-color-level" :class="nameClass">
              <p>Lv.{{ sectionData.level_info.level }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="row-2" v-if="showTimeAndIP">
        <p class="post-time">{{sectionData.create_at | formateDate}}</p>
        <p class="post-addr" v-if="sectionData.ip_location">{{ '·' + sectionData.ip_location }}</p>
      </div>
    </div>
    <div 
      class="follow-btn" 
      :class="followState.state" 
      @click="$hb_tools.linkToUserPage(sectionData.userid)"
    >
      <hb-icon v-if="followState.need_icon" common-add></hb-icon>
      <span class="btn-text">{{ followState.btn_text }}</span>
    </div>
  </div>
</template>
<script>
import FiltersMixin from '../mixins/filters-mixin'
import { getUrlParam } from '_lib/utils'
export default {
  mixins: [FiltersMixin],
  props: {
    linkInfo: {
      type: Object,
      default: () => ({}),
    },
    isConcept: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      follow_state: 0,
      avatar_onload: false
    }
  },
  methods: {
    /**
     * 将hex转成rgba,透明度0.15
     */
    colorHandler (color) {
      var opacity = '0.15';
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      var sColor = color.toLowerCase();
      if (sColor && reg.test(sColor)) {
          if (sColor.length === 4) {
              var sColorNew = '#'
              for (var i = 1; i < 4; i += 1) {
                  sColorNew += sColor.slice(i, i + 1).concat(sColor.slice(i, i + 1))
              }
              sColor = sColorNew
          }
          // 澶勭悊鍏綅鐨勯鑹插€�
          var sColorChange = []
          for (var i = 1; i < 7; i += 2) {
              sColorChange.push(parseInt("0x" + sColor.slice(i, i + 2)))
          }
          return 'rgba(' + sColorChange.join(",") + ',' + opacity + ')'
      } else {
        return sColor;
      }
    },
  },
  computed: {
    showSection () {
      return  Boolean(this.linkInfo.poster)
    },
    sectionData () {
      return {
        ...(this.linkInfo.poster || {}),
        create_at: this.linkInfo.create_at ,
        ip_location: this.linkInfo.ip_location 
      }
    },
    nameClass () {
      return getUrlParam('x_app') == 'maxjia' ? 'max-lv-' : 'static-color-hb-lv-'  + this.sectionData.level_info.level
    },
    medalInfo () {
      let medal
      if (this.sectionData.medal instanceof Array) {
        medal = this.sectionData.medal || []
      } else {
        medal = [this.sectionData.medal] || []
      }
      if (!medal[0] || !medal[0].img_url) return []
      return medal
    },
    followState () {
      const state_enum = {
        0: {
          state: 'unfollowed',
          btn_text: '关注',
          need_icon: true,
        },
        1: {
          state: 'followed',
          btn_text: '已关注',
          need_icon: false
        },
        2: {
          state: 'friend',
          btn_text: '关注',
          need_icon: true
        },
        3: {
          state: 'followboth',
          btn_text: '相互关注',
          need_icon: false
        }
      }
      return state_enum[this.follow_state] || {}
    },
    showTimeAndIP () {
      return !this.isConcept
    }
  }
}
</script>
<style lang="less">
.section-author {
  display: flex;
  align-items: center;
  width: 100%;
  height: 58px;
  padding: 12px;
  background-color: #fff;
  .avatar-wrap {
    position: relative;
    width: 34px;
    height: 34px;
    margin-top: 2px;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPsAAAD7CAMAAACbrBKUAAAAn1BMVEXx8vM5PD/r7O3O0NFydHd+gILw8fHs7e7u7/Du7u9bXmBER0rk5eZAQ0bAwcONkJJ4en1SVVhJTE87PkHn6Ond3t/X2Nq6u72ys7Wdn6FYWl3x8vLg4uNrbW9jZmjT1NaVl5mAg4U9QEPGx8nKzM2mp6lfYWROUVPMzs+pq62jpKaIi41wcnTR0tNGSUysra+KjI6GiIpMT1FFSEuJi41uXjzMAAAEhUlEQVR42uzdi1JaMRSF4b0QjoCgXOTWApaK1BvW2r7/s7XBdjJThEIHkpi1/jf4JuNw9jlOtimllFJKKaWUUkoppZRSSimllFJKKaV276Ox9lF2yrjthYXtov3csCQqQp/7GMD3+6olUBH63E/g+nBu8Qt67t4OPPZt/7I4dwCfLy5tv/KxA52bwvYpJ/u+f/Z52YHHK9u53OzofmvYjmVn3+PXPkP7zn/2Wdp3/LXP1L7Tr32udqBzV9j28rUD9WvbWs52oNWzLeVtR/NTyTaWuR34MixsQ9nbgemtvR2BHaiM7a0o7GiOarYehx1oD2wtFjswWZtueezr0y2RfW26pbL/Nd2S2YGyn27p7PDTLZ8d6HwtzMVoBxar6ZbT/jrdvgN76e6mdkC7n26TtxfDL8DooHY/3aZtv50CQOWwdj/dJmwfz4Aj2oHZOFF7bdTEke04G9VStA/awBHtfrpNzn41AYLY3XSblL3x0EUwO7oPjWTs1ZsnIKAdeLqppmE//wAEs/vpNgF7vwwEtfvpNrL98uIzgtv9dBvRXnztADHsfrqNZV8ugKh2YLGMY583Ed2O5jyGvdpGAna0qxHsQyRhxzCCvXJ4e6eL/atEsJcPbr+wXgV7V87Cfmtm8ymn/eT3Sy9au1npU5PWbtZrhbFXE7SbXdePb68mee6/Ku46R7cneu6vIyKt3az/yGt3r4R47Va9P6O1mzW+dWntZssJr92KT7x2sxaxvU9stymxvSL7+7Yvsbll5vbLLjbVvczcbg/Y1IPlbi9Gi/pbLUZF9vYtyS677LLLLrvssssuu+yyy76DvUZrrxGfe4363GWXXXbZZZdddtlll/1/7KXnl7O3enkuZW9vYVOt3O0NbK6RuT2h/zmR/dD2FrG9TmzHCbF9UvDaMTvltePDOa8deOzz2t1dHLT21R4FWjtQv+a1A60er93dNElrB16GBa0dmM557UBlnKD9NIwdzdFpYvbTMHZ/0+Sc0w5M5rVKFvYZ/quD22cR7INE7IMI9qKehL1eRLBbv5OAvXNlMezWK0e3l3sW1u47r0ey+5dD0exW3DxFsPsLemPYfY0f3dB2fzFzJLvvahLU7i/kTsBuNmgHs/vH40TsVhudBbH7C/jTsbt1CwHsfvFCUnazk2kQu1u4kZzd3TR5RLtftJKi3d80eQS7f+2ZqN2s1zqOffbndXfCdrPrxTHsd68LtRK3u0vpD28vBueFpW/3N00exu57D3a3hILX7m6a5LVb9f47rX110ySt3U23vHY33fLa7XTUpLWbjSu8drdHgdduxfCF1r6abmntbrrltbs9Crx29xGH1r7aqZmSvWRBu5okYy+Fs/vHXF67251Ma3cfcXjtblc6r919xKG1rx5zae3uMZfX7h5zee1uXRitffURh9bu1oXx2t1HHF7773VhY9tennazxnP7wv5RrvZ/J7vssssuu+yyyy677LLLLrvsxprsnMnOmeycyc6Z7JzJzpnsnMn+cyMTjPp9ZIJRv49MMOr3kQlGtt95mEYq4AEA0Tdj8kbuGBgAAAAASUVORK5CYII=);
    background-size: 100% 100%;
    background-position: 50%;
    background-repeat: no-repeat;
    border-radius: 50%;
    &.onload {
      background-image: url('');
    }
    .avatar {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .avatar-decoration {
      width: 48px;
      height: 48px;
      position: absolute;
      top: -7px;
      left: -7px;
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0);
    }
  }
  .user-wrap {
    flex: 1;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-around;
    margin-left: 10px;
    .row-2 {
      display: flex;
      align-items: center;
      margin-top: 3px;
      height: 11px;
      white-space: nowrap;
      line-height: 11px;
      color: #8c9196;
      font-size: 10px;
    }
    .user-info {
      display: flex;
      align-items: center;
    }
    .user-name {
      margin-right: 4px;
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      font-weight: 600;
      color: #14191e;
    }
    .time, .topic {
      height: 11px;
      line-height: 11px;
      font-size: 10px;
      /* line-height: 17px; */
      color: #8c9196;
      white-space: pre;
    }
    .topic {
      position: relative;
      display: flex;
              align-items: center;
      margin-right: 12px;
      &::after {
        content: '';
        position: absolute;
        top: 5px;
        right: -6px;
        width: 1px;
        height: 1px;
        background: #8c9196;
        border-radius: 50%;
      }
    }
    .topic-icon {
      height: 11px;
      width: 11px;
      border-radius: 2px;
      margin-right: 5px;
    }
    .desc {
      font-size: 10px;
      line-height: 17px;
      color: #8c9196;
    }
    span.up-zhu {
      display: inline-block;
      font-weight: 400;
      padding: 1px 5px;
      border-radius: 1px;
      background: #51b0eb;
      color: #fff;
      margin-left: 4px;
      font-size: 12px;
      -webkit-transform: scale(.75);
      transform: scale(.75);
      -webkit-transform-origin: 0 0;
      transform-origin: 0 0
    }
    .medals-wrap {
      display: flex;
      padding: 2px 5px 2px 0;
      > .medal:last-of-type {
        margin-right: 4px;
      }
      .medal-wrap {
        display: flex;
        align-items: center;
        height: 20px;
        margin-top: 0;
        margin-right: 2px;
        padding-left: 0;
        .medal-name {
          font-family: sans-serif;
          font-size: 9px;
          line-height: 12px;
          margin-left: -6px;
          padding-left: 8px;
          padding-right: 2px;
          border-radius: 1px;
          &.static-color-level {
            height: 40px;
            padding: 0 8px;
            margin-left: 0;
            border-radius: 8px;
            font-family: 'Helvetica', sans-serif;
            color: #FFFFFF;
            font-size: 29px;
            text-align: center;
            line-height: 40px;
            font-weight: 700;
            transform: scale(.25);
            p {
              position: relative;
            }
          }
        }
        img {
          width: 16px;
          height: 16px;
          z-index: 1;
        }
      }
    }
  }
  .follow-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 8px;
    height: 24px;
    border-radius: 2px;
    font-weight: 600;
    i {
      display: flex;
      width: 12px;
    }
    &.unfollowed {
      background: #14191e;
      color: #ffffff;
    }
    &.followed {
      background: #f1f2f3;
      color: #8c9196;
    }
    &.friend {
      background: #14191e;
      color: #ffffff;
    }
    &.followboth {
      background: #f1f2f3;
      color: #8c9196;
      font-weight: 400;
    }
    .hbicon-add {
      font-size: 12px;
      margin-right: 2px;
    }
    .btn-text {
      font-size: 12px;
      line-height: 24px;
    }
  }
}
</style>